import { Item, Material, OrganizationLookup, RecyclingRules } from 'types/api.types';
import { apiService } from './apiService';

export const getMaterials = async () => {
  try {
    return await apiService.get<Material[]>('/lookups/materials');
  } catch (error) {
    return null;
  }
};

export const getItems = async () => {
  try {
    return await apiService.get<Item[]>('/lookups/items');
  } catch (error) {
    return null;
  }
};

export const getOrganizations = async () => {
  try {
    return await apiService.get<OrganizationLookup[]>('/lookups/organizations');
  } catch (error) {
    return null;
  }
};

export const searchItems = async (query: string) => {
  try {
    return await apiService.get<Item[]>(`/lookups/items/search?q=${encodeURIComponent(query)}`);
  } catch (error) {
    return null;
  }
};

export const getOrganizationRecyclingRules = async (orgId: number) => {
  try {
    return await apiService.get<RecyclingRules>(`/lookups/organizations/${orgId}/recycling-rules`);
  } catch (error) {
    return null;
  }
};
